import { apiRequest } from "../api/apiClient";

const ROUTE_PREFIX = "payments";

const createOrder = async (amount: number) => {
  const { data, error } = await apiRequest(
    "post",
    `/${ROUTE_PREFIX}/create-order`,
    { amount }
  );

  return { data, error };
};

const verifyPayment = async (payload: any) => {
  const { data, error } = await apiRequest(
    "post",
    `/${ROUTE_PREFIX}/verify`,
    payload
  );

  return { data, error };
};

export { createOrder, verifyPayment };
